export const getOrder = (
  item:
    | 'inicio'
    | 'categorias'
    | 'servicos_destaque'
    | 'servicos_perfil'
    | 'indicadores'
    | 'banners'
    | 'highlight'
    | 'videos'
    | 'canais_atendimento'
    | 'noticias'
    | 'sociais'
    | 'app_governo',
): number => {
  const order: Array<any> =
    process.env.REACT_APP_ORDER_HOME_PAGE.split(',') ?? []

  return order.findIndex((findOrder) => findOrder === item)
}

export default { getOrder }
